import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import Main from './screen/main/main';
import Login from './screen/login/login';
import Profile from './screen/profile/profile';
import PublicProfile from './screen/profile/publicProfile';
import Intro from './screen/intro/intro';
import MyPage from './screen/mypage/mypage';
import ProfileEdit from './screen/mypage/profileEdit';
import Signup from './screen/signup/signup';


function App() {

  return (
      <div className="App">

        <RecoilRoot>
        
          <div className='Main'>
            
            <Routes>
              <Route path="/" element={<Main/>}/>
              <Route path="/login" element={<Login/>}/>
              <Route path="/signup" element={<Signup/>}/>
              <Route path="/intro" element={<Intro/>}/>
              <Route path="/profile" element={<Profile/>}/>
              <Route path="/profile/new" element={<ProfileEdit/>}/>
              <Route path="/profile/edit" element={<ProfileEdit/>}/>
              <Route path="/mypage" element={<MyPage/>}/>
              {/* 공개 프로필 (classicker.com/<handle>). 위의 고정 경로가 우선 매칭됨 */}
              <Route path="/:handle" element={<PublicProfile/>}/>
              
              
            </Routes>
          </div>
        </RecoilRoot>

      </div>
  );
}


export default App;
